import React from 'react';
import SubSection from './sub_section.jsx';
import HostsSubSection from './sub_section_host.jsx';
import Footer from './footer.jsx';

const checkArray = (a) => { return Boolean(a) && !!a.length; };

const Marketplace = ({
  events,
  communities,
  companies,
  popularHosts,
  footerPaths,
  eventsPath,
  communitiesPath,
  companiesPath,
  becomeHostPath
}) => {
  const buildEventCard = (i) => {
    return {
      cardWidth: '300px',
      imgHeight: '142px',
      content: (
        <>
          <p className='marketplace-event-time'>{i.start_time}</p>
          <p className='marketplace-event-location'>{i.location_address}</p>
          <p className='marketplace-event-price'>{i.price}</p>
          <p>{i.community}</p>
        </>
      )
    };
  };

  const buildCommunityCard = (i) => {
    return {
      cardWidth: '300px',
      imgHeight: '201px',
      content: (
        <>
          <p>{i.members_count} Members</p>
        </>
      )
    };
  };

  const buildSponsorCard = (i) => {
    return {
      cardWidth: '250px',
      imgHeight: '168px',
      content: (
        <>
          <p>{i.category}</p>
        </>
      )
    };
  };

  const buildHostCard = (i) => {
    return {
        community: i.community,
        company: i.company
    };
  };

  const buildCards = (array, cardBuilder) => {
    const cards = [];
    array.forEach(i => {
      const card = cardBuilder(i);
      card.key = i.id;
      card.imageUrl = i.image_url;
      card.name = i.name;
      card.path = i.path;
      cards.push(card);
    });
    return cards;
  };

  let title = 'Level up your event \n schedule with Voray.';
  title = title.split('\n').map((item, i) => <p key={i}>{item}</p>);
  let becomeEventHost = 'Find events that are looking for \n amazing hosts like you';
  becomeEventHost = becomeEventHost.split('\n').map((item, i) => <p key={i}>{item}</p>);

  return (
    <>
      <div className='marketplace-background-image-limiter'>
        <div className='marketplace-background-image'>
          <section className='container--extend'>
            <h1 className='marketplace-title'>
              { title.map(i => i) }
            </h1>
          </section>
        </div>
      </div>
      <section className='container--extend'>
        { checkArray(events) && <SubSection title="Upcoming Events" cards={buildCards(events, buildEventCard)} path={eventsPath}/> }
        { checkArray(communities) && <SubSection title="Communities" cards={buildCards(communities, buildCommunityCard)} path={communitiesPath}/> }
        { checkArray(companies) && <SubSection title="Discover Sponsors" cards={buildCards(companies, buildSponsorCard)} path={companiesPath}/> }
        { checkArray(popularHosts) && <HostsSubSection title="Popular Hosts" cards={buildCards(popularHosts, buildHostCard)}/> }
        <div className='marketplace-becomehost-section '>
          <p className='marketplace-becomehost-text-sm'>Become an event host</p>
          <div className='marketplace-becomehost-text-md'>{ becomeEventHost.map(i => i) }</div>
          <a className='btn-main btn-huge btn-wide fs-14' href={becomeHostPath}>Show me</a>
        </div>
        {/*Todo remove this if we will be using  _footer.html.erb
        <Footer {...footer_paths}/>
        */}
      </section>
    </>
  );
};

export default Marketplace;
